import { render } from "./EmptyData.vue?vue&type=template&id=25587342&scoped=true"
import script from "./EmptyData.vue?vue&type=script&lang=js"
export * from "./EmptyData.vue?vue&type=script&lang=js"

import "./EmptyData.vue?vue&type=style&index=0&id=25587342&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25587342"]])

export default __exports__